import { NotificationChannel } from './types'

export const NOTIFICATION_CHANNEL_OPTIONS: Record<
  NotificationChannel,
  { value: NotificationChannel; label: string }
> = {
  'tg-bot': { label: 'Тг бот', value: 'tg-bot' },
  email: { label: 'Почта', value: 'email' },
  mobile: { label: 'Мобильное приложение', value: 'mobile' },
  web: { label: 'На платформе', value: 'web' },
}
